import seedrandom from 'seedrandom';

import { V4 } from '@moleculeone/utils';
import { getSmallestCycles } from './selectors';
import { setPositions, setUnchangedPositions } from './methods';
import { DEFAULT_RANDOM_SEED } from './const';
import Bonding from './bonding';
import Repulsion from './repulsion';
import Bending from './bending';
import Cycler from './cycler';

const normalBonding = new Bonding(100, 10);
const normalRepulsion = new Repulsion(100, 1);
const normalBending = new Bending(1);
const normalCycler = new Cycler(10);

export function relax(mol, weights, params = {}) {
  const { randomSeed = DEFAULT_RANDOM_SEED } = params;
  let { iters = 1 } = params;

  const random = seedrandom(randomSeed);

  let result = mol;
  const cycles = getSmallestCycles(result);
  while (iters > 0) {
    iters--;
    result = relaxOnce(random, result, weights, cycles);
  }
  return setPositions(mol, result.positions);
}

export function relaxOnce(random, mol, weights = {}, cycles = getSmallestCycles(mol)) {
  const forces = {};
  for (const k of Object.keys(mol.atoms)) {
    forces[k] = [];
  }
  normalBending.apply(mol, forces);
  normalBonding.apply(mol, forces);
  normalRepulsion.apply(random, mol, forces);
  normalCycler.apply(mol, forces, cycles);
  const positions = { ...mol.positions };
  for (const key of Object.keys(positions)) {
    let fsum = V4.add.apply(null, forces[key]);
    if (V4.norm(fsum) > 1) {
      fsum = V4.normal(fsum, 1);
    }
    fsum = V4.scale(fsum, 1 / (weights[key] || 1));
    positions[key] = V4.add(positions[key], fsum);
  }
  return setUnchangedPositions(mol, positions);
}
